import api from '../api/axiosConfig';

export const candidatesApi = {
    create: async (orgId, candidate) => {
        const response = await api.post(`/candidates/create?org_id=${orgId}`, candidate, {
            loadingMessage: 'Создание кандидата...',
            successMessage: 'Кандидат успешно создан'
        });
        return response;
    },

    getList: async (skip = 0, limit = 20, org_id, filters = {}) => {
        const params = { skip, limit, ...filters };
        
        const response = await api.get('/candidates/', {
            params: org_id ? { ...params, org_id } : params,
            silent: true
        });
        // Возвращаем и items, и total_pages, и total_items из ответа бэкенда
        return {
            items: response.data.data.items || response.data.data,
            total_pages: response.data.data.total_pages,
            total_items: response.data.data.total_items
        };
    },

    getById: async (id, organisationId) => {
        const response = await api.get(`/candidates/${id}?org_id=${organisationId}`, {
            silent: true
        });
        return response.data.data;
    },

    getByVacancy: async (vacancyId, skip = 0, limit = 20) => {
        const response = await api.get(`/candidates/vacancies/${vacancyId}`, {
            params: { skip, limit },
            silent: true
        });
        return response.data;
    },

    update: async (id, organisationId, candidate) => {
        const response = await api.put(`/candidates/${id}?org_id=${organisationId}`, candidate, {
            loadingMessage: 'Обновление данных кандидата...',
            successMessage: 'Данные кандидата успешно обновлены'
        });
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`/candidates/${id}`, {
            loadingMessage: 'Удаление кандидата...',
            successMessage: 'Кандидат успешно удалён'
        });
        return response.data;
    },

    getHistory: async (id, organisationId) => {
        const response = await api.get(`/candidates/${id}/history?org_id=${organisationId}`, {
            silent: true
        });
        return response.data.data;
    },

    addFile: async (id, organisationId, file) => {
        const response = await api.post(`/candidates/${id}/files?org_id=${organisationId}`, file, {
            loadingMessage: 'Загрузка файла...',
            successMessage: 'Файл успешно загружен'
        });
        return response.data;
    },

    getFiles: async (id, organisationId) => {
        const response = await api.get(`/candidates/${id}/files?org_id=${organisationId}`, {
            silent: true
        });
        return response.data.data;
    },

    delFiles: async (file_id) => {
        const response = await api.delete(`/candidates/files/${file_id}`, {
            loadingMessage: 'Удаление файла...',
            successMessage: 'Файл успешно удалён'
        });
        return response.data;
    }
};